import styled from 'styled-components';
import theme from '../../themes/default';

const Div = styled.div`
  font-family: ${theme.fonts.primary};
  color: ${theme.palette.foreground};
`;

export default Div;
